import { useState } from 'react';
import MojitoPresentation from 'mojito/presentation';
import SearchResultRow from 'applications/sports/components/search/search-discovery-view/search-result-row/index.js';

const { Button, FlexPane, Image, Text } = MojitoPresentation.Components;

const SearchResultSection = props => {
    const {
        isPlayerGroup,
        items,
        onNavigate,
        title,
        mojitoTools: { config, stringResolver, style },
    } = props;
    const [expanded, setExpanded] = useState(false);
    const visibleItems = expanded ? items : items.slice(0, config.rowsLimit);
    const canExpand = items.length > config.rowsLimit;

    return (
        <FlexPane config={config.container} class="ta-SearchResultSection">
            <Text config={config.title} class="ta-searchResultSectionTitle">
                {title}
            </Text>
            <FlexPane config={config.resultsContainer} class="ta-searchResultRows">
                {visibleItems.map(item => (
                    <SearchResultRow
                        key={item.id}
                        config={config.row}
                        item={item}
                        isPlayerGroup={isPlayerGroup}
                        onNavigate={onNavigate}
                    />
                ))}
            </FlexPane>
            {canExpand && (
                <Button
                    config={config.toggleButton}
                    class="ta-searchResultSectionToggle"
                    onClick={() => setExpanded(current => !current)}
                >
                    <Text config={config.toggleText}>
                        {stringResolver.resolveString(
                            expanded
                                ? '$SEARCH_DISCOVERY_VIEW.SHOW_LESS'
                                : '$SEARCH_DISCOVERY_VIEW.SHOW_MORE'
                        )}
                    </Text>
                    <Image config={expanded ? style.collapseIcon : config.expandIcon} />
                </Button>
            )}
        </FlexPane>
    );
};

// Merge the collapse variant over the base icon so DBX overrides only the differences.
SearchResultSection.getStyle = (config, mode, merge) => ({
    collapseIcon: merge(config.expandIcon, config.collapseIcon),
});

export default SearchResultSection;
